import { Article } from '@teko/ecommerce';
import { Container, ContainerProps } from '@teko/ds-mobile';

type SiteDescriptionStyleProps = Omit<ContainerProps, 'children'>;
interface SiteDescriptionProps extends SiteDescriptionStyleProps {
  content?: string;
}

export const SiteDescription = ({
  content,
  ...props
}: SiteDescriptionProps) => {
  return (
    <Container {...props} padding="s4" paddingBottom="s16">
      <Article content={content || ''} />
    </Container>
  );
};
